import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e09d759e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = { class: "recent-chatbots" }
const _hoisted_3 = { class: "background" }
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "chatbots-label" }, "Zuletzt geöffnet", -1))
const _hoisted_6 = {
  key: 0,
  class: "chatbots"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "add"),
  /*#__PURE__*/_createElementVNode("span", null, "Neuen Chatbot erstellen")
], -1))
const _hoisted_8 = {
  key: 1,
  class: "chatbots loader"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "add"),
  /*#__PURE__*/_createElementVNode("span", null, "Neuen Chatbot erstellen")
], -1))
const _hoisted_10 = { class: "all-chatbots" }
const _hoisted_11 = { class: "wrapper" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "chatbots-label" }, "Alle Chatbots", -1))
const _hoisted_13 = {
  key: 0,
  class: "chatbots"
}
const _hoisted_14 = {
  key: 1,
  class: "chatbots loader"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "legal" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://chatcaptain.com/imprint.html",
      target: "_blank"
    }, "Impressum")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://chatcaptain.com/sbt.html",
      target: "_blank"
    }, "AGB")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://chatcaptain.com/privacy.html",
      target: "_blank"
    }, "Datenschutz")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_card = _resolveComponent("md-card")!
  const _component_overview_chatbot_card = _resolveComponent("overview-chatbot-card")!
  const _component_overview_chatbot_loader = _resolveComponent("overview-chatbot-loader")!
  const _component_chatbot_create_overlay = _resolveComponent("chatbot-create-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "left",
          style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.HeaderImageLeft + ')' })
        }, null, 4),
        _createElementVNode("div", {
          class: "right",
          style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.HeaderImageRight + ')' })
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.chatbots && _ctx.chatbots.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_md_card, {
                class: "create-new",
                variant: "elevated",
                clickable: "",
                onClick: _ctx.openCreateChatbotOverlay
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatbots, (chatbot, key) => {
                return (_openBlock(), _createBlock(_component_overview_chatbot_card, {
                  key: key,
                  chatbot: chatbot,
                  onClick: ($event: any) => (_ctx.redirectToChatbot(chatbot))
                }, null, 8, ["chatbot", "onClick"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_md_card, {
                class: "create-new",
                variant: "elevated",
                clickable: "",
                onClick: _ctx.openCreateChatbotOverlay
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["onClick"]),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                return _createVNode(_component_overview_chatbot_loader, { key: n })
              }), 64))
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        (_ctx.chatbots && _ctx.chatbots.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatbots, (chatbot, key) => {
                return (_openBlock(), _createBlock(_component_overview_chatbot_card, {
                  key: key,
                  chatbot: chatbot,
                  onClick: ($event: any) => (_ctx.redirectToChatbot(chatbot))
                }, null, 8, ["chatbot", "onClick"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                return _createVNode(_component_overview_chatbot_loader, { key: n })
              }), 64))
            ]))
      ])
    ]),
    _hoisted_15,
    _createVNode(_component_chatbot_create_overlay, {
      ref: "createChatbotOverlay",
      onClose: _ctx.loadChatbots
    }, null, 8, ["onClose"])
  ]))
}